import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">{contactInfo.title}</h2>
        </div>
        <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto mb-8 leading-relaxed">
          {contactInfo.description}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactInfo.items.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-400">{item.label}</span>
              <span className="text-sm font-bold text-foreground-700">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}